import { useEffect, useMemo, useRef, useState } from "react";
import CustomImage from "./CustomImage";
import { displayDateTime } from "../services/functions";
import "../reviews.css";
import { getRandomIconColors } from "../utility/colorUtils"; // reuse from earlier
import { buildRatingMap, getStarArray } from "../utility/ratingUtils";

const ReviewItem = ({ el, rating }) => {
  const user = el?.user?.[0];
  const avatarColors = getRandomIconColors(user?.name);
  const initial = user?.name?.charAt(0).toUpperCase();
  const stars = getStarArray(rating); // always an array now, never null

  return (
    <li className="rv-item" key={el?._id}>
      <div className="rv-item__header">

        {/* Avatar */}
        {el?.profilePhoto ? (
          <CustomImage
          className="rv-item__avatar rv-item__avatar--img"
          state={{ image: user?.profilePhoto, name: user?.name }}
          size="38px"
          />
        ) : (
          <div className="rv-item__avatar" style={avatarColors}>
            {initial}
          </div>
        )}

        {/* Name + Date */}
        <div className="rv-item__meta">
          <p className="rv-item__name">{user?.name}</p>
          <p className="rv-item__date">{displayDateTime(el?.createdAt)}</p>
        </div>

         {/* Star Rating — optional, remove if not used */}
         {/* Per-user star rating */}
         {/* JSX — render only if there are stars */}
        {stars.length > 0 && (
          <div className="rv-item__stars">
            {stars.map((filled, i) => (
              <i key={i} className={`fa ${filled ? "fa-star" : "fa-star-o"}`} />
            ))}
          </div>
        )}
      </div>
      <p className="rv-item__comment">{el?.comment}</p>
    </li>
  );
};

const CommentModel = ({ detailsData }) => {
  const commentByOthersData = detailsData?.commentByOthers;
  const ratingByOthersData = detailsData?.ratingByOthers || [];
  const userName = detailsData?.name || "";
  const categoryName = detailsData?.category?.[0]?.name || "";

  const modalRef = useRef(null);
  const isEmpty = !commentByOthersData?.length;

  const closeModal = async () => {
    if (modalRef.current && window.$) {
      $(modalRef.current).modal("hide");
    }
    const modalElement = document.getElementById('commentModal');
    if (modalElement) {
      $(modalElement).modal('hide');
    }
  }

  // Build once, reuse for every item
  const ratingMap = useMemo(
    () => buildRatingMap(ratingByOthersData),
    [ratingByOthersData]
  );

  return (
    <div
      className="modal fade"
      id="commentModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="commentModalLabel"
      aria-hidden="true"
      ref={modalRef}
    >
      <div className="modal-dialog modal-fullscreen" role="document">
        <div className="modal-content rv-modal-content">

          {/* Header */}
          <div className="rv-header">
            <div>
              <p className="rv-header__title" id="commentModalLabel">Reviews</p>
              {!isEmpty && (
                <p className="rv-header__count">
                  {commentByOthersData.length} review{commentByOthersData.length !== 1 ? "s" : ""}
                </p>
              )}
            </div>
            <div className="heading">
              <div className="rv-item__name">{userName} </div>
              <div className="rv-header__count text-capitalize">{categoryName}</div>
            </div>
            <button className="rv-close-btn" onClick={closeModal} aria-label="Close">
              <i className="fa fa-times" />
            </button>
          </div>

          {/* Body */}
          <div className="modal-body rv-list-wrapper">
            {isEmpty ? (
              <div className="rv-empty">
                <i className="fa fa-comments-o rv-empty__icon" />
                <p>No reviews yet.</p>
              </div>
            ) : (
              <ul className="rv-list">
                {[...commentByOthersData].reverse().map((el) => {
                const userId = el?.user?.[0]?._id || el?.user?.[0];
                const userRating = ratingMap[userId] ?? null;

                return (
                  <ReviewItem key={el?._id} el={el} rating={userRating} />
                );
              })}
              </ul>
            )}
          </div>

          {/* Footer */}
          <div className="modal-footer rv-footer">
            <button className="rv-close-footer-btn" onClick={closeModal}>
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default CommentModel;
